import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../services/app-settings';
import { ApiServiceProvider } from '../api-service/api-service';



/*
  Generated class for the AnimalServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnimalServiceProvider {
  API_URL: string;
  
  //apiUrl = 'http://171.244.40.238:5000/GetAnimalList';
  //API_URL : any  = AppSettings.CB_SERVER_CONFIG.APIDomain + "animal/";
  //API_URL : any  = AppSettings.CB_SERVER_CONFIG.APIDomain + "animal/";

  constructor(public http: HttpClient,public apiService:ApiServiceProvider) {
    console.log('Hello AnimalServiceProvider Provider');
  }

  async getAnimalCategories()
  {
    var animalCates: any = {};
    let params = {
      categoryID: -1,
   }

    animalCates = await this.apiService.post(this.apiService.api.login, params);

    console.log("animalCates authen form server" + animalCates);
    console.log(animalCates);
    return animalCates;
  }

  async getAnimalBy_AnimnalCode(pAnimalCode) {
    console.log("somebody called: --- getAnimalListByCategoryType ");
    var params:any;

    params = {
      animalCode: pAnimalCode,      
    }

    var res: any = {};
    console.log(this.API_URL + "getAnimalDetailByCode/");

    res = await this.apiService.get("animal/getAnimalDetailByCode", params);
    return res.data_animal;

  }

//----------------------------------------------------------------------------

  async getAnimalListByCategoryType(pAnimalType) {
    console.log("somebody called: --- getAnimalListByCategoryType ");
    var params:any;

    params = {
      catName: pAnimalType,      
    }

    var res: any = {};
    console.log(this.API_URL + "getAnimalCategory/");

    res = await this.apiService.get("animal/getAnimalListByCategoryType", params);
    return res.data_animal;

  }


//----------------------------------------------------------------------------

  async getAnimalCategoryList() {
    console.log("somebody called: --- getAnimalCategoryList ")
    var res: any = {};
    console.log(this.API_URL + "getAnimalCategory/");

    res = await this.apiService.get("animal/getAnimalCategory");
    return res.data_animal;
  }
}



// WEBPACK FOOTER //
// ./src/providers/animal-service/animal-service.ts